package one.healthium.log_food.ui.scan_results

import androidx.compose.runtime.Immutable
import one.healthium.profile.ui.food.models.AmountUiModel
import one.healthium.profile.ui.food.models.FoodUiModel
import one.healthium.profile.ui.food.models.FoodUiOptions
import kotlin.time.Clock
import kotlin.time.Instant

@Immutable
data class ScanResultFoodItem(
    val food: FoodUiModel,
    val amount: AmountUiModel,
) {
    val calories: Float get() = food.calories * amount.hundredGrams
    val carbohydrates: Float get() = food.carbohydrates * amount.hundredGrams
    val fat: Float get() = food.fat * amount.hundredGrams
    val protein: Float get() = food.protein * amount.hundredGrams
    val fiber: Float get() = food.fiber * amount.hundredGrams
}

@Immutable
data class ScanResultsUiState(
    val foodItems: List<ScanResultFoodItem> = emptyList(),
    val selectedDate: Instant = Clock.System.now(),
    val isLoading: Boolean = false,
    val selectedAmountIndex: Int? = null,
    val showDatePicker: Boolean = false,
) {
    val isSingleItem: Boolean get() = foodItems.size == 1
    val totalCalories: Float get() = foodItems.sumOf { it.calories.toDouble() }.toFloat()
    val totalCarbs: Float get() = foodItems.sumOf { it.carbohydrates.toDouble() }.toFloat()
    val totalFat: Float get() = foodItems.sumOf { it.fat.toDouble() }.toFloat()
    val totalProtein: Float get() = foodItems.sumOf { it.protein.toDouble() }.toFloat()
    val totalFiber: Float get() = foodItems.sumOf { it.fiber.toDouble() }.toFloat()
    val selectedAmount: AmountUiModel? get() = selectedAmountIndex?.let { foodItems.getOrNull(it)?.amount }
    val singleItemOptions: FoodUiOptions? get() = if (isSingleItem) {
        FoodUiOptions(foodItems[0].amount, foodItems[0].food, selectedDate)
    } else null
    val allOptions: List<FoodUiOptions> get() = foodItems.map { item ->
        FoodUiOptions(item.amount, item.food, selectedDate)
    }
}
